import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material';
import DatePicker from "../partials/pickers/DatePicker";
import TimeListPicker from "../partials/pickers/TimeListPicker";
import { useNavigate } from "react-router-dom";
import { BoxContainer } from '../layouts/Theme';
import { useI18N } from '../context/I18NContext';
export default function Reschedule(props) {
    const navigate = useNavigate();
    const theme = useTheme();
    const { t } = useI18N();
    const goTo = (e) => {
        let target = e.target.closest('button');
        if (!target) {
            target = e.target.closest('li');
        }
        let path = target.getAttribute('rel');
        navigate(`/oa_widget_${path}`);
    };
    return (_jsxs(BoxContainer, { children: [_jsx(Typography, { sx: { color: theme.palette.text.primary }, variant: "h6", children: t('Verplaatsen van je afspraak') }), _jsx(Typography, { sx: { color: theme.palette.text.primary, my: 1 }, variant: "body1", children: t('Je staat op het punt om onderstaande afspraak te verzetten:') }), _jsx(Alert, { sx: { my: 1 }, severity: "info", variant: "filled", children: "Donderdag 22 mei, 19:30, Kick-boxen, Zaal 1" }), _jsx(Button, { onClick: goTo, rel: 'appointments', fullWidth: true, sx: { my: 1 }, variant: "outlined", children: "Niet verzetten" }), _jsx(Typography, { sx: { color: theme.palette.text.primary }, variant: "body1", children: t('Kies een nieuwe datum en tijd voor je afspraak.') }), _jsx(DatePicker, { source: "date" }), _jsx(TimeListPicker, { source: "time", config: { redirect: "rescheduled" } })] }));
}
